export function updateLanguageSwitches() {
	$("[data-language-switch]").hide();
	$("[data-language-switch=" + STORY_IQ.CURRENT_LANGUAGE_CODE + "]").show();
}

export function updateLanguageLinks() {
	$("[data-language-links]").each(function () {
		let $link = $(this);
		let language_urls = $link.attr("data-language-links");
		if (language_urls.length) {
			let language_json = JSON.parse(language_urls);
			let current_code = STORY_IQ.CURRENT_LANGUAGE_CODE.toString().toLowerCase();
			for (let language_code in language_json) {
				if (language_code == current_code) {
					$link.attr("href", language_json[language_code]);
				}
			}
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/components/languageSwitcher.ts